import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1.jpg",
  heading: "App Development Services",
  description: `Empower your business with innovative and scalable mobile app solutions. We build performance-driven, intuitive apps tailored to your goals. Whether it's Android, iOS, or cross-platform, we create reliable mobile experiences that resonate with your users and grow your brand.`,

  middleImage: "/images/service/sr-d-1-2.jpg",
  features: [
    "Custom Android & iOS Development",
    "Cross-Platform Compatibility",
    "User-Centric UI/UX Design",
    "End-to-End App Lifecycle Management",
  ],

  challengeHeading: "Challenges in App Development",
  challengeParagraphs: [
    `Creating engaging and responsive applications across multiple platforms requires not just coding but a deep understanding of user behavior. Ensuring smooth performance while integrating diverse APIs and security protocols is a key challenge.`,

    `Scalability, user retention, and regular updates are essential to the app's success. Our team tackles these with agile methodologies and robust architecture to deliver apps that perform flawlessly under real-world conditions.`,
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg",
  ],
};

const AppDevelopment = () => (
  <Fragment>
    <Seo
  title="App Development - Tech Ayukta"
  description="Tech Ayukta provides high-performance mobile app development services for Android, iOS, and cross-platform applications. We build scalable, secure, and user-friendly mobile apps using modern technologies such as React Native, Flutter, and custom native development."
  keywords="
    Tech Ayukta App Development,
    Mobile App Development,
    Android App Development,
    iOS App Development,
    Cross-Platform App Development,
    React Native Apps,
    Flutter App Development,
    Custom Mobile Application Development,
    Enterprise Mobile Apps,
    Mobile UI UX Design,
    App Prototyping,
    Hybrid App Development,
    Native App Development,
    App Maintenance Services,
    Best App Development Company
  "
  canonical="https://www.techayukta.com/services/app-development"
/>

    <HeaderThree />
    <Breadcrumb
      pageName="App Development"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default AppDevelopment;
